"use strict";
function throwError(e) { throw e; }
exports.throwError = throwError;
//# sourceMappingURL=throwError.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/throwError.js
 ** module id = 50
 ** module chunks = 2
 **/